import MainCard from '@/components/MainCard';
import React, { useEffect, useState } from "react";
import { Table, Typography, Tag, Input, Popconfirm } from "antd";
import Icons from '@/components/third-party/Icons';
import {
  get_all_batch_machine_cleaning_operation,
  update_cleaning_status,
} from '@/utils/api';
import { toast } from "react-toastify";
// Ant Design components are used instead of MUI
import { useDispatch, useSelector } from "react-redux";
import useTableConfig from '@/hooks/useTableConfig';
import TableColumnConfig from '@/components/TableColumnConfig';
const CheckCleaning = () => {
  const expandedRowRender = (machines) => {
    const machineColumns = [
      {
        title: "Machine Name",
        dataIndex: "machine_name",
        key: "machine_name",
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        render: (status) => (status ? "Cleared" : "Not Cleared"),
      },
    ];

    return (
      <Table
        columns={machineColumns}
        dataSource={machines}
        pagination={false}
        rowKey="table_pk"
      />
    );
  };
  const selectedModule = useSelector((state) => state.moduleView);
  const [searchvalue, setSearchvalue] = useState("");
  const [check_cleaning_data, set_check_cleaning_data] = useState([
    // {
    //   batch_number: "IR01_XJEC1129",
    //   machines: [
    //     {
    //       machine_id: 25,
    //       machine_name: "SSCF/HDPE Container",
    //       table_pk: 1,
    //       status: true,
    //     },
    //     {
    //       machine_id: 26,
    //       machine_name: "Machine 2",
    //       table_pk: 2,
    //       status: false,
    //     },
    //   ],
    // },
    // {
    //   batch_number: "IR02_ABC",
    //   machines: [
    //     {
    //       machine_id: 27,
    //       machine_name: "Machine 3",
    //       table_pk: 3,
    //       status: true,
    //     },
    //   ],
    // },
    // {
    //   batch_number: "IR03_DEF",
    //   machines: [
    //     {
    //       machine_id: 28,
    //       machine_name: "Machine 4",
    //       table_pk: 4,
    //       status: false,
    //     },
    //     {
    //       machine_id: 29,
    //       machine_name: "Machine 5",
    //       table_pk: 5,
    //       status: true,
    //     },
    //   ],
    // },
    // {
    //   batch_number: "IR04_GHI",
    //   machines: [
    //     {
    //       machine_id: 30,
    //       machine_name: "Machine 6",
    //       table_pk: 6,
    //       status: true,
    //     },
    //   ],
    // },
    // {
    //   batch_number: "IR05_JKL",
    //   machines: [
    //     {
    //       machine_id: 31,
    //       machine_name: "Machine 7",
    //       table_pk: 7,
    //       status: false,
    //     },
    //   ],
    // },
  ]);
  const MachineCleaningStatus = () => {
    // Flatten data for table and track rowSpans
    const flattenedData = [];
    check_cleaning_data?.forEach((batch) => {
      batch.machines?.forEach((machine, index) => {
        flattenedData.push({
          key: `${batch.batch_number}_${machine.table_pk}`,
          batch_number: batch.batch_number,
          machine_name: machine.machine_name,
          id: machine?.table_pk,
          status: machine.status,
          batch_rowspan: index === 0 ? batch.machines.length : 0,
        });
      });
    });
    return flattenedData;
  };
  const confirm = (record) => {
    update_cleaning(record);
  };

  const allColumns = [
    {
      title: "Batch Number",
      dataIndex: "batch_number",
      key: "batch_number",
      defaultVisible: true,
      sortable: true,
      sortType: "string",
      render: (text, row, index) => {
        const obj = {
          children: text,
          props: {},
        };
        if (row.batch_rowspan > 0) {
          obj.props.rowSpan = row.batch_rowspan;
        } else {
          obj.props.rowSpan = 0;
        }
        return obj;
      },
    },
    {
      title: "Machine Name",
      dataIndex: "machine_name",
      key: "machine_name",
      defaultVisible: true,
      sortable: true,
      sortType: "string",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      align: "center",
      defaultVisible: true,
      sortable: true,
      sortType: "boolean",
      render: (status) =>
        status ? (
          <Tag color="green">Cleaned</Tag>
        ) : (
          <Tag color="red">Not Cleaned</Tag>
        ),
    },
    {
      title: "Action",
      dataIndex: "",
      key: "action",
      align: "center",
      defaultVisible: true,
      sortable: false,
      render: (data, record) => {
        return record?.status ? (
          <Tooltip title="Cleaned">
            <Icons.CheckCircle className="w-5 h-5" color="green" />
          </Tooltip>
        ) : (
          <Popconfirm
            title="Are you sure the machine has been cleaned?"
            onConfirm={() => confirm(record)}
            //onCancel={()=>cancel)}
            okText="Yes"
            placement={"left"}
            cancelText="No"
          >
            <Tooltip title="Update Cleaning Status">
              <Icons.Paintbrush className="w-5 h-5" color="blue" />
            </Tooltip>
          </Popconfirm>
        );
      },
    },
  ];

  const { visibleColumns, columnConfigMenu, filteredData } = useTableConfig({
    tableKey: "check_cleaning_config",
    columns: allColumns,
    data: MachineCleaningStatus(),
    searchValue: searchvalue,
  });

  const update_cleaning = async (data) => {
    const { id, status } = data;
    const payload = {
      id: id,
      status: !status,
    };
    try {
      await update_cleaning_status(payload, (response) => {
        console.log("response", response.data);
        if (response?.data?.status !== "failed") {
          toast.success(response?.data?.message);
          get_all_batch_machine_cleaning_data();
        } else {
          toast.error(response?.data?.message);
        }
      });
    } catch (error) {
      console.error("Error updating cleaning status:", error);
    }
  };

  const get_all_batch_machine_cleaning_data = async () => {
    try {
      await get_all_batch_machine_cleaning_operation(
        { module_type: selectedModule },
        successupdate
      );
    } catch (error) {
      console.error("Error fetching cleaning data:", error);
    }
  };

  const successupdate = (res) => {
    if (res?.data?.status !== "failed") {
      set_check_cleaning_data(res?.data?.data);
    } else {
      set_check_cleaning_data([]);
    }
  };

  useEffect(() => {
    try {
      get_all_batch_machine_cleaning_data();
    } catch (error) {
      console.error("Error fetching cleaning data:", error);
    }
  }, [selectedModule]);

  return (
    <>
      <MainCard title={"Equipment Cleaning Log"}>
        <Grid container spacing={1}>
          <Grid item xs={12} lg={12}>
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              justifyContent="end"
              style={{ marginTop: "-40px" }}
            >
              <Input.Search
                placeholder="Search here..."
                className="my-1"
                size="large"
                style={{ width: "15%" }}
                onSearch={(value) => {
                  setSearchvalue(value);
                }}
                onChange={(e) => setSearchvalue(e.target.value)}
              />
              <TableColumnConfig menu={columnConfigMenu} className="mb-3" />
            </Stack>
          </Grid>
          <Grid item xs={12} lg={12}>
            <Table
              columns={visibleColumns}
              dataSource={filteredData}
              bordered
              pagination={{
                pageSize: 10,
                showSizeChanger: true,
                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
              }}
              scroll={{ x: 'max-content' }}
            />
          </Grid>
        </Grid>
      </MainCard>
    </>
  );
};

export default CheckCleaning;
